<template>
  <v-container>
    <v-treeview
      selectable
      :items="getScientificFields"
      v-model="selectedPodrucja"
      selected-color="primary"
      :selection-type="selectionType"
      transition
      return-object
      :active="selectedPodrucja"
    >
      <template v-slot:label="{ item }">
        <v-card color="transparent" tile elevation="0">
          <v-card-title
            style="font-style: normal; font-size: 16px; font-weight: normal"
          >
            {{ item.naziv }}
            <v-spacer></v-spacer>
          </v-card-title>
        </v-card>
        <v-divider></v-divider>
      </template>
    </v-treeview>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["currentStep"],
  data() {
    return {
      search: "",
      selectionType: "all",
      // selectedPodrucja: []
    };
  },
  computed: {
    ...mapGetters(["getScientificFields", "getSelectedPodrucja"]),
    selectedPodrucja: {
      set(value) {
        if (value) {
          this.$store.dispatch("setSelectedPodrucja", value);
        }
      },
      get() {
        return this.getSelectedPodrucja;
      },
    },
  },
  watch: {
    currentStep(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$store.dispatch("setSelectedTypes", this.selectedFields);
      }
    },
  },
  beforeMount() {
    this.$store.dispatch("getScientificFields");
  },
};
</script>
